(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-grid/assets/javascripts/casino-grid-skeleton.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-grid/assets/javascripts/casino-grid-skeleton.js');
'use strict';

const CasinoCardWrapper = svs.components.casino_react.CasinoCardWrapper;
const _svs$components$casin = svs.components.casino_react.common.constants,
  GridRulesets = _svs$components$casin.GridRulesets,
  DefaultNumberOfCasinoGridItems = _svs$components$casin.DefaultNumberOfCasinoGridItems;
const CasinoGridSkeleton = _ref => {
  let displayMode = _ref.displayMode;
  const ruleset = GridRulesets[displayMode];
  const loadingItems = Array(ruleset.maxItems ? ruleset.maxItems : DefaultNumberOfCasinoGridItems * 2).fill({});
  return React.createElement("ul", {
    className: "casino-grid ".concat(ruleset.classList.join(' '))
  }, loadingItems.map((_, idx) =>
  React.createElement(CasinoCardWrapper, {
    key: "item-".concat(idx)
  }, React.createElement("div", {
    className: "casino-grid__item"
  }))));
};
setGlobal('svs.components.casino_react.CasinoGridSkeleton', CasinoGridSkeleton);

 })(window);